import React, { useCallback, useEffect, useState } from "react"

import { Stack } from "@mui/material"

import { StyledProductionStepsTextarea } from "../StyledSectionComponents"
import FormikErrorMessage from "../../../FormikErrorMessage"
import { debounce } from "lodash"

const StepDescriptionField = ({
  index,
  onFieldFocus,
  onFieldBlur,
  onKeyUp,
  hasError,
  getFieldName,
  value,
  setFieldValue,
  isReusable,
  sectionIndex
}) => {
  const [localValue, setLocalValue] = useState("")
  
  // set the initial value of the step description
  useEffect(() => {
    if (!value) return
    setLocalValue(value)
  }, [])

  // update the step description in the form level after 2 seconds
  const handleDebouncedChange = debounce((value, sectionIndex, stepIndex) => {
    if (isReusable) {
      setFieldValue(`productionSteps[${stepIndex}].description`, value)
      return
    }
    setFieldValue(`sections[${sectionIndex}].productionSteps[${stepIndex}].step.description`, value)
  }, 2000)
  
  const handleClick = (event) => event.stopPropagation()

  // update the step description in the local field level
  const handleChange = useCallback((event) => {
    // to ensure that React will keep the event object as is even after the debounce
    event.persist()
    const value = event.target.value
    setLocalValue(value)
    handleDebouncedChange(value,sectionIndex, index)
  }, [sectionIndex, index])

  return (
    <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
      <Stack direction="row" spacing={1} alignItems="center">
        <StyledProductionStepsTextarea
          value={localValue}
          onChange={handleChange}
          onClick={handleClick}
          onFocus={onFieldFocus}
          onBlur={onFieldBlur}
          onKeyUp={onKeyUp}
          error={!!hasError(index, "description")}
        />
      </Stack>
      <FormikErrorMessage
        name={getFieldName("description")}
      />
    </Stack>
  )
}

export default StepDescriptionField
